var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareIcon = function SvgShareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeWidth: 1.4,
    d: "M6 7.5v7.68c0 1.233 0 1.85.263 2.31a2 2 0 0 0 .746.747c.46.263 1.077.263 2.311.263h5.36c1.234 0 1.85 0 2.31-.263.312-.177.57-.435.747-.746.263-.46.263-1.078.263-2.311V7.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-text, #EBEBEB)",
    d: "m12.01 2 .422-.56L11.31 2zm-.42.56 3.989 3 .841-1.12-3.989-3zm1.138 11.039-.017-11.6-1.4.002.017 11.6z"
  })));
};
export default SvgShareIcon;